import { ModalVisualMode } from '@ui-components/containers/ModalTypes'
import { AfterCareStep, AfterCareStepProps } from '@ui-components/layout/AfterCareStep'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'

import { AnalyticsService, CommonAnalyticsModalName } from '../analytics'
import { useGlobalServices } from '../hooks/useGlobalServices'
import { OpenModalEvent, ShowModalOptions } from './Modal'

export interface CommonAfterCareStepProps extends AfterCareStepProps {
  analyticsService: AnalyticsService<string, string, CommonAnalyticsModalName>
  sentModalProps: Partial<ShowModalOptions> | null
}

export const CommonAfterCareStep = ({
  children,
  sentModalProps,
  analyticsService,
  ...rest
}: CommonAfterCareStepProps) => {
  const { formatMessage } = useIntl()
  const { openModal } = useGlobalServices()

  useEffect(() => {
    if (sentModalProps !== null) {
      const modalAnalyticsName = 'AfterCareModal'
      const openEvent: OpenModalEvent = {
        type: 'OPEN',
        data: {
          header: formatMessage({ id: 'common-after-care-application-sent-modal-heading' }),
          children: null,
          primaryButtonOptions: {
            label: formatMessage({ id: 'common-continue' }),
            type: 'primary',
            onClick: () => analyticsService.sendCustomEvent(modalAnalyticsName, 'ConfirmButton'),
          },
          mode: ModalVisualMode.Happy,
          ...sentModalProps,
        },
      }
      analyticsService.sendModalViewEvent(modalAnalyticsName)
      openModal(openEvent.data)
    }
  }, [analyticsService, formatMessage, openModal, sentModalProps])

  return (
    <AfterCareStep twoColumnLayoutSupport={false} fullViewportHeight={false} {...rest}>
      {children}
    </AfterCareStep>
  )
}
